import user from './user';
import customer from './customer';
import role from './role';
import company from './company';
import apiKeys from './apiKeys';
import area from './area';
import building from './building';
import file from './file';
import fireProtection from './fireProtection';
import flaw from './flaw';
import floor from './floor';
import mapItem from './mapItem';
import map from './map';
import questionGroup from './questionGroup';
import questionList from './questionList';
import question from './question';
import roundHistoryInfo from './roundHistoryInfo';
import roundHistoryItem from './roundHistoryItem';
import roundHistoryQuestion from './roundHistoryQuestion';
import roundHistory from './roundHistory';
import roundPlanning from './roundPlanning';
import round from './round';
import customerLicense from './customerLicense';

export default {
	user,
	customer,
	role,
	company,
	apiKeys,
	area,
	building,
	file,
	fireProtection,
	flaw,
	floor,
	mapItem,
	map,
	questionGroup,
	questionList,
	question,
	roundHistoryInfo,
	roundHistoryItem,
	roundHistoryQuestion,
	roundHistory,
	roundPlanning,
	round,
	customerLicense
};
